<template>
  <div class="">
    <p>جست و جو</p>
    <b-form-input
        @keypress.enter.prevent="search"
        v-model="searchWords"
        placeholder="جستجو"
        class="flex-grow-1"
    ></b-form-input>
    <b-button
        @click="search"
        variant="primary"
        class="mt-2"
    >
      جستجو
    </b-button>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      searchWords: '',
    }
  },
  methods: {
    search() {
      let page = 1
      this.$store.commit('Product/setFilters', {key: 'search', value: this.searchWords})
      this.$emit('updateFilter', {search: this.searchWords})
      this.$store.dispatch("Product/setDashboardProducts", page);
    }
  },
  mounted() {
    const value = this.$route.query.search;
    if (value != undefined) {
      this.$store.commit('Product/setFilters', {key: 'search', value: value})
    }
  },
  destroyed() {
    this.$store.commit('Product/setFilters', {key: 'search', value: ''})
  }
}
</script>

<style scoped>

</style>